import assertNever from 'assert-never';

import { FirmwareUpdateJobRequest, ScheduledJobRequest, ScheduledJobType } from '@shure/cloud/shared/models/devices';

import { ScheduledJobRequestFragment } from '../graphql/generated/cloud-sys-api';

export function mapScheduledJobRequestFromSysApi(
	scheduledJobRequest: ScheduledJobRequestFragment
): ScheduledJobRequest {
	if (scheduledJobRequest.details.__typename === 'FirmwareUpdateJobRequestDetails') {
		const jobRequest: FirmwareUpdateJobRequest = {
			id: scheduledJobRequest.id,
			type: ScheduledJobType.FirmwareUpdate,
			status: scheduledJobRequest.status,
			jobId: scheduledJobRequest.job.jobId,
			executeAt: scheduledJobRequest.job.executeAt,
			deviceHardwareId: scheduledJobRequest.details.task.device.hardwareId,
			packageKey: scheduledJobRequest.details.task.packageKey,
			packageVersion: scheduledJobRequest.details.task.packageVersion,
			hosted: scheduledJobRequest.details.task.hosted
		};

		return jobRequest;
	}

	return assertNever(scheduledJobRequest.details.__typename);
}
